<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title"></span>
        <div class="mdl-layout-spacer"></div>
      </div>
    </header>    
    <SideMenu></SideMenu>
    <main class="mdl-layout__content">
      <div class="page-content">

        <div class="eula-card" v-if="is_active">

          <h4>Olá, {{ currentName }}</h4>

          <EulaText></EulaText>

          <p><strong>Aceita os termos de uso?</strong></p>

          <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored" v-on:click="acceptEula">
            Sim
          </button>
          <button class="mdl-button mdl-js-button mdl-button--raised" v-on:click="rejectEula">
            Não
          </button>

        </div>

      </div>
    </main>
  </div>
</template>
<script>

  import Vue from 'vue'
  import firebase from 'firebase/app'
  import db from './firebaseInit'
  import localDb from './localDb'
  import * as moment from 'moment'
  import SideMenu from './SideMenu.vue'
  import EulaText from './EulaText.vue'

  var instancePath = 'instances/' + process.env.FSM_ENV
  var currentUser = localStorage.getItem('currentUser')
  var operatorRef = db.doc(instancePath + '/people/' + currentUser)

  export default {
    components: {
      SideMenu,
      EulaText
    },
    data: function() {
      return {
        currentName: localStorage.getItem('currentName'),
        currentUser: localStorage.getItem('currentUser'),
        demo: process.env.FSM_DEMO,
        instancePath: instancePath,
        coords: '',
        is_active: true
      }  
    },
    mounted() {
      if (localStorage.getItem('currentUser') == null) {
        this.$router.push("/login")
      }
      if (localStorage.getItem('accepted_eula') == 'yes') {
        this.$router.push("/calendar")
      }
    },
    methods: {
      acceptEula: function() {

        var data = this;
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(
            function(position) {
              data.coords = position.coords.latitude + ',' + position.coords.longitude;
              data.updateOperator()
            },
            function(error) {
              data.coords = "Indisponivel (codigo " + error.code + ")";
              data.updateOperator()
            }
          );
        } else {
          data.save()
        }
      },      
      rejectEula: function() {
        localStorage.removeItem('currentName')
        localStorage.removeItem('currentUser')
        this.$router.push("/login")
      },
      updateOperator: function() {
        db.doc(instancePath + '/people/' + localStorage.getItem('currentUser')).update({
          accepted_eula: 'yes',
          accepted_date: moment().toISOString(),
          browser_string: navigator.appVersion,
          accepted_coords: this.coords
        })
        localStorage.setItem('accepted_eula', 'yes')
        this.$router.push("/calendar")
      }
    }
  }
  
</script>
<style>
  .eula-card {
    background-color: white;
    margin: 10px;
    padding: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/WelcomeView.vue